export function imageSequenceIconsSwap() {
  // === inside your imageSequenceIconsSwap() module ===
  (function () {
    const XLINK = "http://www.w3.org/1999/xlink";
    const REG = new WeakMap();

    function setHref(el, url) {
      const tag = (el.tagName || "").toLowerCase();
      if (tag === "image") {
        el.setAttribute("href", url);
        el.setAttributeNS(XLINK, "xlink:href", url);
      } else {
        el.src = url;
      }
    }
    function getHref(el) {
      const tag = (el.tagName || "").toLowerCase();
      if (tag === "image") {
        return el.getAttribute("href") || el.getAttributeNS(XLINK, "href") || "";
      }
      return el.currentSrc || el.src || "";
    }
    function defaultSrcFor({ basePath, pad = 2, ext = "webp" }) {
      const p = (n) => String(n).padStart(pad, "0");
      return (i) => `${basePath}${p(i)}.${ext}`;
    }

    window.makeImageSequence = function (o = {}) {
      const {
        target,
        totalFrames,
        fps = 24,
        mode = "once",
        srcFor,
        basePath = "",
        pad = 2,
        ext = "webp",
        trigger = null,
        start = "top 80%",
        ioThreshold = 0.2,
        paintInitial = true, // <-- NEW
        initialFrame = 0, // <-- NEW
      } = o;

      const el = typeof target === "string" ? document.querySelector(target) : target;
      if (!el || !totalFrames) return null;

      if (REG.has(el)) return REG.get(el);

      const getSrc = srcFor || defaultSrcFor({ basePath, pad, ext });
      const st = { fps: Math.max(1, +fps || 24), frame: 0, rafId: null, playing: false, destroyed: false };

      function setFrame(i) {
        const clamped = Math.max(0, Math.min(totalFrames - 1, i | 0));
        if (st.frame === clamped && getHref(el) === getSrc(clamped)) return; // don't repaint same frame
        st.frame = clamped;
        setHref(el, getSrc(clamped));
      }

      function _tick(lastRef) {
        const fd = 1000 / st.fps;
        const now = performance.now();
        const elapsed = now - lastRef.v;
        if (elapsed >= fd) {
          const steps = Math.max(1, Math.floor(elapsed / fd));
          lastRef.v = now;
          let next = st.frame + steps;
          if (next >= totalFrames) {
            if (mode === "loop") next = next % totalFrames;
            else {
              setFrame(totalFrames - 1);
              st.playing = false;
              st.rafId = null;
              return;
            }
          }
          setFrame(next);
        }
        st.rafId = requestAnimationFrame(() => _tick(lastRef));
      }

      function play() {
        if (st.destroyed || st.playing) return;
        st.playing = true;
        const lastRef = { v: performance.now() };
        st.rafId = requestAnimationFrame(() => _tick(lastRef));
      }
      function pause() {
        st.playing = false;
        if (st.rafId) cancelAnimationFrame(st.rafId);
        st.rafId = null;
      }
      function goto(i) {
        pause();
        setFrame(i);
      }
      function setFps(n) {
        st.fps = Math.max(1, +n || 24);
      }
      function destroy() {
        pause();
        st.destroyed = true;
        REG.delete(el);
        st._st?.kill?.();
        st._io?.disconnect?.();
      }

      // Paint first frame (optionally)
      if (paintInitial !== false) {
        // only if different from what’s already there
        if (getHref(el) !== getSrc(initialFrame)) setFrame(initialFrame);
      }

      // (No visibility wiring here in your minimal version)

      const api = { play, pause, goto, setFps, destroy };
      REG.set(el, api);
      return api;
    };
  })();
}
